export default [
    {
        name: 'SIT',
        label: 'Situação'
    },
    {
        name: 'CD_FIL',
        label: 'Filial'
    },
    {
        name: 'NM_DEPOSITO_ADIC',
        label: 'Depósito de Entrega'
    },
    {
        name: 'NR_PC',
        label: 'Nº ped.'
    },
    {
        name: 'CD_NUM',
        label: 'Cód. num'
    },
    {
        name: 'CD_ALFA',
        label: 'Alfa'
    },
    {
        name: 'NM_PROD',
        label: 'N. Prod.'
    },
    {
        name: 'AB_COR1',
        label: 'Cor'
    },
    {
        name: 'QTD',
        label: 'Qtd'
    },
];